// src/components/Landing/LandingForm.jsx
import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import TagManager from 'react-gtm-module';
import styles from './LandingForm.module.scss';
import { submitLandingForm } from '../../api/LandingApi';
import maquinariaData from '../../data/maquinariaData.json';

const LandingForm = ({ country, privacyPolicy }) => {
  const [formData, setFormData] = useState({
    name: '',
    lastname: '',
    phone: '',
    email: '',
    city: '',
    company: '',
    ruc: '',
    machines: ''
  });
  const [selectedMachines, setSelectedMachines] = useState([]);
  const [modal, setModal] = useState({ visible: false, message: '', type: '' });
  const formRef = useRef(null);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(fd => ({ ...fd, [name]: value }));
  };

  const handleToggleMachine = id => {
    setSelectedMachines(prev => {
      const next = prev.includes(id) ? prev.filter(m => m !== id) : [...prev, id];
      const names = maquinariaData
        .filter(m => next.includes(m.id))
        .map(m => m.name)
        .join(',');
      setFormData(fd => ({ ...fd, machines: names }));
      return next;
    });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      await submitLandingForm(formData);
      if (typeof window !== 'undefined') {
        TagManager.dataLayer({
          dataLayer: {
            event: 'ux_event',
            event_name: 'formulario_enviado',
            event_category: 'engagement',
            event_label: `Formulario de - ${country}`,
            value: 1
          }
        });
      }
      setModal({ visible: true, message: '¡Mensaje enviado exitosamente!', type: 'success' });
    } catch {
      setModal({
        visible: true,
        message: 'Hubo un error al enviar el formulario. Por favor, inténtalo nuevamente.',
        type: 'error'
      });
    }
  };

  const fields = [
    { id: 'name',    label: 'Nombres', required: true,  type: 'text' },
    { id: 'lastname',label: 'Apellidos',  required: true,  type: 'texto' },
    { id: 'phone',   label: 'Teléfono',            required: true,  type: 'tel' },
    { id: 'email',   label: 'Correo electrónico',  required: true,  type: 'email' },
    { id: 'city',    label: 'Ciudad',              required: true,  type: 'text' },
    { id: 'company', label: 'Empresa',             required: false, type: 'text' },
    { id: 'ruc',     label: 'RUC',                 required: false, type: 'text' }
  ];

  return (
    <div ref={formRef} className={styles.section}>
      <h2 className={styles.title}>Pongámonos en contacto</h2>
      <div className={styles.content}>
        <form onSubmit={handleSubmit} className={styles.form}>
          {fields.map(({ id, label, type, required }) => (
            <div key={id} className={styles.group}>
              <label htmlFor={id}>{label}:</label>
              <input
                id={id}
                name={id}
                type={type}
                value={formData[id]}
                onChange={handleChange}
                required={required}
              />
            </div>
          ))}

          {/* Grupo de tags abarcando ambas columnas en desktop */}
          <div className={`${styles.group} ${styles.tagsGroup}`}>
            <label>Máquinas de interés:</label>
            <div className={styles.tagsContainer}>
              {maquinariaData.map(({ id, name }) => (
                <motion.div
                  key={id}
                  className={`${styles.tag} ${selectedMachines.includes(id) ? styles.selected : ''}`}
                  onClick={() => handleToggleMachine(id)}
                  whileHover={{ scale: 1.1, y: -5 }}
                  transition={{ type: 'spring', stiffness: 300 }}
                >
                  {name}
                </motion.div>
              ))}
            </div>
          </div>

          <button type="submit" className={styles.submitButton}>
            Enviar
          </button>
          <a
            href={privacyPolicy}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.privacyLink}
          >
            Política de privacidad
          </a>
        </form>
      </div>

      {modal.visible && (
        <div className={styles.modal}>
          <div className={styles.modalContent}>
            <p>{modal.message}</p>
            <button
              className={styles.modalClose}
              onClick={() => setModal({ visible: false, message: '', type: '' })}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LandingForm;
